import { ArrowLeftIcon } from '@heroicons/react/24/outline'

export const Voltar = ({ onClick }) => {
	return (<>
		<button className="btn-voltar" type='button' onClick={onClick}>
			<ArrowLeftIcon width={20} />
		</button>
	</>)
}